(function () {
  if (window.__cartUpsellInitialized) return
  window.__cartUpsellInitialized = true

  const upsellSourceSelector = '#cart-drawer-upsell-wrapper'
  const upsellSelector = '#cart-drawer-upsell'
  let refreshTimer
  let renderingUpsell = false

  function renderCartUpsell(target, source) {
    if (!target || !source) return

    const sourceUpsell = source.querySelector(upsellSelector)
    const existingUpsell = target.querySelector(upsellSelector)

    if (existingUpsell) existingUpsell.remove()
    if (!sourceUpsell) return

    target.insertAdjacentHTML('beforeend', sourceUpsell.outerHTML)

    const renderedUpsell = target.querySelector(upsellSelector)
    if (
      renderedUpsell &&
      !renderedUpsell.querySelector('.cart-drawer-upsell-list li')
    ) {
      renderedUpsell.remove()
    }
  }

  function getCartDrawerTarget() {
    const cartDrawerItems = document.querySelector(
      '#CartDrawer cart-drawer-items'
    )
    if (!cartDrawerItems) return null

    if (cartDrawerItems.classList.contains('is-empty')) {
      const existingUpsell = document.querySelector(
        '#CartDrawer #cart-drawer-upsell'
      )
      if (existingUpsell) existingUpsell.remove()
      return null
    }

    let wrapper = cartDrawerItems.closest('.cart-drawer-items-wrapper')
    if (!wrapper) {
      wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)
    }

    return wrapper
  }

  function insertSectionCartDrawer(source = document.querySelector(upsellSourceSelector)) {
    renderCartUpsell(getCartDrawerTarget(), source)
  }

  function insertSectionCartPage(source = document.querySelector(upsellSourceSelector)) {
    const cartItems = document.querySelector('#MainContent cart-items')
    if (!cartItems) return

    const target = cartItems.querySelector('.page-width')
    renderCartUpsell(target, source)
  }

  function renderCartUpsells(source = document.querySelector(upsellSourceSelector)) {
    if (!source) return

    renderingUpsell = true
    insertSectionCartDrawer(source)
    insertSectionCartPage(source)

    setTimeout(() => {
      renderingUpsell = false
    }, 0)
  }

  async function refreshCartUpsells() {
    const response = await fetch(window.location.href)
    const text = await response.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')
    const newSource = newDocument.querySelector(upsellSourceSelector)
    if (!newSource) return

    const currentSource = document.querySelector(upsellSourceSelector)
    if (currentSource) currentSource.replaceWith(newSource)

    renderCartUpsells(newSource)
  }

  function scheduleCartUpsellRefresh() {
    if (renderingUpsell) return
    if (refreshTimer) clearTimeout(refreshTimer)

    refreshTimer = setTimeout(() => {
      refreshTimer = undefined
      refreshCartUpsells()
    }, 250)
  }

  function observeCart(selector) {
    const element = document.querySelector(selector)
    if (!element) return

    const observer = new MutationObserver(scheduleCartUpsellRefresh)
    observer.observe(element, {
      attributes: true,
      childList: true,
      subtree: true,
    })
  }

  renderCartUpsells()

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault()
    const imgSrc = select.options[select.selectedIndex].dataset.variantImg
    const item = select.closest('.cart-drawer-upsell-list-item')
    const img = item?.querySelector('.cart-drawer-upsell-list-item-left img')

    if (imgSrc && img) img.src = imgSrc
  }

  observeCart('cart-drawer')
  observeCart('#MainContent .cart__items')
})()
